/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CardSchemesConfiguration
 */
export interface CardSchemesConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof CardSchemesConfiguration
     */
    visaEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardSchemesConfiguration
     */
    mastercardEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardSchemesConfiguration
     */
    amexEnabled?: boolean;
}

/**
 * Check if a given object implements the CardSchemesConfiguration interface.
 */
export function instanceOfCardSchemesConfiguration(value: object): value is CardSchemesConfiguration {
    return true;
}

export function CardSchemesConfigurationFromJSON(json: any): CardSchemesConfiguration {
    return CardSchemesConfigurationFromJSONTyped(json, false);
}

export function CardSchemesConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardSchemesConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'visaEnabled': json['visaEnabled'] == null ? undefined : json['visaEnabled'],
        'mastercardEnabled': json['mastercardEnabled'] == null ? undefined : json['mastercardEnabled'],
        'amexEnabled': json['amexEnabled'] == null ? undefined : json['amexEnabled'],
    };
}

export function CardSchemesConfigurationToJSON(json: any): CardSchemesConfiguration {
    return CardSchemesConfigurationToJSONTyped(json, false);
}

export function CardSchemesConfigurationToJSONTyped(value?: CardSchemesConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'visaEnabled': value['visaEnabled'],
        'mastercardEnabled': value['mastercardEnabled'],
        'amexEnabled': value['amexEnabled'],
    };
}

